<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>收劵机构简介</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <!-- 角色默认新增 -->
          <!-- <el-button @click="addDataNew" type="primary" v-if="isCollecting">新增</el-button> -->
          <el-button @click="addDataNew" type="primary">新增</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>

          <el-select
            v-model="serviceOrgStatus"
            placeholder="请选择审核状态"
            clearable
            style="display: block;width: 200px;"
            @change="searchSelect"
          >
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="3"></el-option>
            <el-option label="通过" :value="4"></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column label="机构名称" align="center" prop="name"></el-table-column>
            <el-table-column label="服务类型" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.serviceType | filterType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="联系人" align="center" prop="contactPerson"></el-table-column>
            <el-table-column label="服务电话" align="center" prop="servicePhone"></el-table-column>

            <el-table-column label="审核状态" align="center">
              <template slot-scope="{ row }">
                <div>{{ row.serviceOrgStatus | filterStatus }}</div>
              </template>
            </el-table-column>

            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="isCollecting && scope.row.publishedFlag === 0 && scope.row.serviceOrgStatus === 4"
                  type="danger"
                  @click="handlePush(scope.$index, scope.row)"
                >
                  发布
                </el-button>

                <el-button
                  class="mini_btn"
                  size="mini"
                  v-else-if="isCollecting && scope.row.publishedFlag === 1 && scope.row.serviceOrgStatus === 4"
                  type="danger"
                  @click="handlePush(scope.$index, scope.row)"
                >
                  取消发布
                </el-button>
                <!-- 收券机构 并且 审批为退回状态可修改 -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="isCollecting && scope.row.serviceOrgStatus === 3"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  修改
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDetail(scope.$index, scope.row)"
                >
                  详情
                </el-button>

                <!-- 除了待审核，其他状态都可以删除 -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="isCollecting && scope.row.serviceOrgStatus !== 1"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="Title"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-form-item label="机构名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入机构名称"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务类型" prop="serviceType">
            <el-select
              v-model="ruleForm.serviceType"
              placeholder="请选择服务类型"
              clearable
              style="display: block;"
              :disabled="isDetail"
              @change="selectChange($event, serviceTypeList, 'serviceTypeName')"
            >
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in serviceTypeList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="联系人" prop="contactPerson">
            <el-input
              v-model="ruleForm.contactPerson"
              placeholder="请输入联系人"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务电话" prop="servicePhone">
            <el-input
              v-model="ruleForm.servicePhone"
              placeholder="请输入服务电话"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <!--<el-form-item label="地址" prop="orgProvince">
            <v-distpicker
              style="text-align:left;"
              @selected="citySelected"
              :province="ruleForm.orgProvince"
              :city="ruleForm.orgCity"
              :area="ruleForm.orgDistrict"
              :disabled="isDetail"
            ></v-distpicker>
          </el-form-item>-->
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="ruleForm.address"
              placeholder="请填写详细地址"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="机构简介" prop="briefIntroduction">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入机构简介"
              v-model="ruleForm.briefIntroduction"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务资质" prop="serviceQualification">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入服务资质"
              v-model="ruleForm.serviceQualification"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务内容" prop="serviceContent">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入服务内容"
              v-model="ruleForm.serviceContent"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="单位logo" prop="logo">
            <el-upload
              class="avatar-uploader"
              :action="this.uploadURL"
              list-type="picture-card"
              name="file"
              :file-list="logo"
              :before-upload="beforeAvatarUpload"
              :disabled="isDetail"
              :limit="limit"
              ref="upload0"
              :on-success="
                (response, file, fileList) =>
                  handleAvatarSuccess(response, file, fileList, 'logo')
              "
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!isDetail"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, 'logo')"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <div slot="tip" class="el-upload__tip" v-if="showUpload1 && !isDetail">
                只允许上传一张图片
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="实景图" prop="realPicture">
            <el-upload
              class="avatar-uploader"
              :action="this.uploadURL"
              list-type="picture-card"
              name="file"
              :file-list="realPicture"
              :before-upload="beforeAvatarUpload"
              :disabled="isDetail"
              :limit="limit"
              ref="upload1"
              :on-success="
                (response, file, fileList) =>
                  handleAvatarSuccess(response, file, fileList, 'realPicture')
              "
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!isDetail"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, 'realPicture')"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <div slot="tip" class="el-upload__tip" v-if="showUpload2 && !isDetail">
                只允许上传一张图片
              </div>
            </el-upload>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
            <el-switch
              v-model="ruleForm.publishedFlag"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
              :disabled="isDetail"
            ></el-switch>
          </el-form-item>
        </el-row>
        <div class="form-title" v-if="dialogType === 'detail'">审核信息</div>
        <el-row>
          <el-col :span="12" v-if="dialogType === 'detail'">
            <el-form-item label="审批状态" prop="serviceOrgStatus" style="text-align:left">
              <el-select
                v-model="ruleForm.serviceOrgStatus"
                placeholder="请选择审核状态"
                style="display: block;"
                :disabled="isDetail"
              >
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="审核意见" prop="auditOpinion" v-if="dialogType === 'detail'">
              <el-input
                v-model="ruleForm.auditOpinion"
                placeholder="请填写审核意见"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="附件上传" v-if="dialogType === 'detail'">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :disabled="isDetail"
            :before-upload="beforeFileUploadLimit"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, 'file')"
            :limit="1"
            :file-list="file"
            :on-success="
              (response, file, fileList) => handleFileSuccess(response, file, fileList, 'file')
            "
            list-type="picture"
          >
            <el-button
              size="small"
              type="primary"
              :disabled="isDetail"
            >
              上传附件材料
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editOperate" v-if="dialogType !== 'add'">
          修 改
        </el-button>
        <el-button type="primary" @click="createSite" v-if="dialogType === 'add'">确 定</el-button>
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from '../../../components/common-layout.vue';
const serviceType = {
  1: '检测检验',
  2: '委托开发',
  3: '专利申请代理',
  4: '技术转移'
};
const serviceOrgStatus = {
  1: '待审核',
  2: '不通过',
  3: '退回',
  4: '通过'
};
export default {
  components: {
    CommonLayout
  },
  filters: {
    filterType(state) {
      return serviceType[state];
    },
    filterStatus(state) {
      return serviceOrgStatus[state];
    }
  },
  data() {
    return {
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      serviceOrgStatus: '',
      formApprovalStatus: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      serviceTypeList: [
        {
          label: '检测检验',
          id: 1
        },
        {
          label: '委托开发',
          id: 2
        },
        {
          label: '专利申请代理',
          id: 3
        },
        {
          label: '技术转移',
          id: 4
        }
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      logo: [],
      realPicture: [],
      file: [],

      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      orgTypeList: [],
      investmentList: [],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 20,
      ruleForm: {
        name: null, // 机构名称
        serviceType: null, // 机构类型id
        contactPerson: null, // 联系人
        servicePhone: null, // 服务电话
        // orgProvince: null, // 通讯地址-省
        // orgCity: null, // 通讯地址-市
        // orgDistrict: null, // 通讯地址-区
        address: null, // 通讯地址-详细地址
        briefIntroduction: null, // 机构简介
        serviceQualification: null, // 服务资质
        serviceContent: null, // 服务内容
        logo: null, // logo
        realPicture: null, // 实景图
        publishedFlag: 0, // 是否发布
        serviceOrgStatus: 1, // 审批状态
        auditOpinion: null, // 审批意见
        file: null, // 上传附件
      },
      rules: {
        name: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        serviceType: [{ required: true, message: '请选择服务类型', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        servicePhone: [{ required: true, message: '请输入服务电话', trigger: 'blur' }],
        // orgProvince: [{ required: true, message: '请选择机构地址-省', trigger: 'change' }],
        // orgCity: [{ required: true, message: '请选择机构地址-市', trigger: 'change' }],
        // orgDistrict: [{ required: true, message: '请选择机构地址-区', trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        briefIntroduction: [{ required: true, message: '请输入机构简介', trigger: 'blur' }],
        serviceQualification: [{ required: true, message: '请输入服务资质', trigger: 'change' }],
        serviceContent: [{ required: true, message: '请输入服务内容', trigger: 'change' }],
        logo: [{ required: true, message: '请上传logo图片', trigger: ['blur', 'change'] }],
        realPicture: [{ required: true, message: '请上传实景图', trigger: ['blur', 'change'] }],
        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: ['blur', 'change'] }],
        serviceOrgStatus: [{ required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }]
      },
      tableData: [],
      limit: 1,
      showUpload1: false,
      showUpload2: false
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getData();
    this.getGroup();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logo: {
      handler() {
        this.checkLimit(this.logo, 0);
      }
    },
    realPicture: {
      handler() {
        this.checkLimit(this.realPicture, 1);
      }
    }
  },
  methods: {
    beforeFileUploadLimit(file) {
      if (this.file.length === 1) {
        return this.$message.warning('您已经上传了一份附件，请删除后重新上传');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleFileRemove(file, fileList, type) {
      this.file = fileList;
      this.fileListChange(type);
      // if (fileList.length === 0) {
      //   this.ruleForm.file = '';
      // } else {
      //   this.ruleForm.file = JSON.stringify(fileList);
      // }
    },
    handleFileSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.file = fileList;
        this.fileListChange(type);
        // if (fileList.length === 0) {
        //   this.ruleForm.file = '';
        // } else {
        //   this.ruleForm.file = JSON.stringify(fileList);
        // }
      }
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        await this.getDetail();
      }
    },
    async getDetail() {
      console.log(this.isCollecting,999999999)
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/innovation/introduction/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          // this.ruleForm = res.data;
          this.ruleForm = Object.assign(this.ruleForm, res.data);
          this.realPicture = res.data.realPicture ? JSON.parse(res.data.realPicture) : [];
          this.logo = res.data.logo ? JSON.parse(res.data.logo) : [];
          this.file = res.data.file ? JSON.parse(res.data.file) : [];
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getData() {
      console.log('this.listQuery.serviceOrgStatus', this.listQuery.serviceOrgStatus);
      if (this.listQuery.serviceOrgStatus === null) {
        this.$delete(this.listQuery, 'serviceOrgStatus');
      }
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/innovation/introduction/page',
          this.listQuery
        )
        .then(res => {
          if (res.code == 0) {
            let arr = res.data.data;
            arr.forEach(item => {
              if (item.logo) {
                item.imgSrc = JSON.parse(item.logo)[0].url;
              } else {
                item.imgSrc = '';
              }
            });
            this.tableData = arr;
            // this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_institution_category', 'financial_investment_stage']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            console.log('response', response);
            this.orgTypeList = response.data.financial_institution_category;
            this.investmentList = response.data.financial_investment_stage;
            // this.ruleForm = response.data
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (uploadDom) {
        if (filelist.length === limit) {
          uploadDom.$children[1].$el.style.display = 'none';
          this['showUpload' + (index + 1)] = true;
        } else {
          uploadDom.$children[1].$el.style.display = '';
          this['showUpload' + (index + 1)] = false;
        }
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/introduction/update`, this.ruleForm)
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    searchSelect(e) {
      if (e) {
        this.listQuery.serviceOrgStatus = e;
        this.getData();
      } else {
        this.$delete(this.listQuery, 'serviceOrgStatus');
        this.getData();
      }
    },
    resetData() {
      this.ruleForm = {
        name: null, // 机构名称
        serviceType: null, // 机构类型id
        contactPerson: null, // 联系人
        servicePhone: null, // 服务电话
        // orgProvince: null, // 通讯地址-省
        // orgCity: null, // 通讯地址-市
        // orgDistrict: null, // 通讯地址-区
        address: null, // 通讯地址-详细地址
        briefIntroduction: null, // 机构简介
        serviceQualification: null, // 服务资质
        serviceContent: null, // 服务内容
        logo: null, // logo
        realPicture: null, // 实景图
        publishedFlag: 0, // 是否发布
        serviceOrgStatus: null, //审批状态
        auditOpinion: null, // 审批意见
        file: null, // 上传附件
      };
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    deleteImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.fileListChange(type, []);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.serviceOrgStatus;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '详情';
      this.dialogType = 'detail';
      this.disabled = true;
      this.queryId = row.id;
      this.formApprovalStatus = row.serviceOrgStatus;
    },
    handleDelete(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
      .then(() => {
        this.http.delete(`${urlConfig.devUrl}apij2/admin-api/innovation/introduction/delete?id=${row.id}`).then(res => {
          if (res.code === 0) {
            this.resetData();
            this.getData();
            this.$message({
              type: 'success',
              message: '删除成功',
            });
          } else {
            this.$message({
              message: '失败！',
              type: 'error',
            });
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.logo = [];
      this.realPicture = [];
      this.file = [];
    },
    handlePush(index, row) {
      const params = { ...row };
      params.publishedFlag = row.publishedFlag === 1 ? 0 : 1;
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/innovation/introduction/update`, params)
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: params.publishedFlag === 1 ? '发布成功！' : '取消发布成功！'
            });
            this.getData();
          }
        });
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        console.log(this.ruleForm)
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/introduction/create`, this.ruleForm)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('新增成功');
                this.dialogFormVisible = false;
                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .rowItem1 {
    float: left;
  }
}
</style>
